import { createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "flex flex-col gap-1" };
const _hoisted_2 = ["aria-checked", "data-state", "disabled", "data-disabled", "id", "data-static-id", "name", "onKeydown"];
const _hoisted_3 = {
    key: 0,
    class: "text-sm text-foreground leading-none"
};
const _hoisted_4 = {
    key: 0,
    class: "text-xs text-destructive"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("label", {
            class: _normalizeClass(["flex items-center gap-2 cursor-pointer select-none", { 'cursor-not-allowed opacity-50': $props.isDisabled || $props.disabled }]),
            onClick: _withModifiers($setup.onClick, ["prevent"])
        }, [
            _createElementVNode("button", {
                type: "button",
                role: "radio",
                "aria-checked": $setup.isChecked,
                "data-state": $setup.isChecked ? 'checked' : 'unchecked',
                disabled: $props.isDisabled || $props.disabled,
                "data-disabled": $props.isDisabled || $props.disabled ? '' : undefined,
                id: $props.id ?? $props.staticId ?? undefined,
                "data-static-id": $props.id ?? $props.staticId ?? undefined,
                name: $props.name,
                class: _normalizeClass($setup.cn('group border-input text-primary focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 relative aspect-square size-4 shrink-0 rounded-full border shadow-xs transition-[color,background-color,border-color,box-shadow] duration-150 outline-none focus-visible:ring-3 disabled:cursor-not-allowed disabled:opacity-50', $setup.props.class)),
                onClick: _withModifiers($setup.onClick, ["stop", "prevent"]),
                onBlur: $setup.onBlur,
                onKeydown: [
                    _withKeys(_withModifiers($setup.onClick, ["prevent"]), ["space"]),
                    _withKeys(_withModifiers($setup.onClick, ["prevent"]), ["enter"])
                ]
            }, [
                _createVNode($setup["CircleIcon"], { class: "fill-en-red-500 stroke-en-red-500 absolute top-1/2 left-1/2 size-2.5 -translate-x-1/2 -translate-y-1/2 scale-0 opacity-0 transition-all duration-150 group-data-[state=checked]:scale-100 group-data-[state=checked]:opacity-100" })
            ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_2),
            ($props.label || _ctx.$slots.default)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                    _renderSlot(_ctx.$slots, "default", {}, () => [
                        _createTextVNode(_toDisplayString($props.label), 1 /* TEXT */)
                    ])
                ]))
                : _createCommentVNode("v-if", true)
        ], 2 /* CLASS */),
        ($setup.errorMessage)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString($setup.errorMessage), 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
    ]));
}
